import { render, staticRenderFns } from "./TotalStudentDegree.vue?vue&type=template&id=9aa426e8"
import script from "./TotalStudentDegree.vue?vue&type=script&lang=js"
export * from "./TotalStudentDegree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports